<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        评估仪器管理
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="search"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="reset"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterForm"
          :model="filter"
          :inline="true"
          class="c-form c-condition__form"
          label-width="90px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="仪器名称"
                prop="yqmc"
              >
                <el-input
                  v-model.trim="filter.yqmc"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="仪器编号"
                prop="yqbh"
              >
                <el-input
                  v-model.trim="filter.yqbh"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="可用仪器">
          <k-table
            height="100%"
            :table-column="columns"
            :data="rows"
            :pagination-show="false"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { pgxmManageService } from '../pgxm/pgxm.service';

export default {
  name: 'JxxfPgyqManage',
  data () {
    return {
      loading: false,
      filter: { yqmc: '', yqbh: '' },
      sourceRows: [],
      columns: [
        { key: 'index', label: '序号', width: '65', align: 'center', type: 'index' },
        { key: 'yqmc', label: '仪器名称', minWidth: '180', align: 'left', type: 'text' },
        { key: 'yqbh', label: '仪器编号', minWidth: '150', align: 'left', type: 'text' },
        { key: 'jdzsbh', label: '检定/校准证书编号', minWidth: '190', align: 'left', type: 'text' },
        { key: 'jdyxqZ', label: '检定有效期', width: '130', align: 'center', type: 'date' }
      ]
    };
  },
  computed: {
    rows () {
      const name = this.filter.yqmc.toLowerCase();
      const code = this.filter.yqbh.toLowerCase();
      return this.sourceRows.filter(item =>
        (!name || (item.yqmc || '').toLowerCase().includes(name)) &&
        (!code || (item.yqbh || '').toLowerCase().includes(code))
      );
    }
  },
  methods: {
    search () {
      this.loading = true;
      pgxmManageService.instruments().then(rsp => {
        this.sourceRows = rsp.data || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    reset () {
      this.$refs.filterForm.resetFields();
    }
  },
  created () {
    this.search();
  }
};
</script>
